'use client'

import { useTranslations } from 'next-intl'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ElementLibrary } from '@/components/element-library'
import { popModal } from '@/components/modals'

interface ElementLibraryModalProps {
  onClose: () => void
}

export function ElementLibraryModal({ onClose }: ElementLibraryModalProps) {
  const t = useTranslations('element-library')

  const handleClose = () => {
    popModal()
    onClose?.()
  }

  return (
    <DialogContent
      className="!fixed !left-1/2 !top-1/2 !-translate-x-1/2 !-translate-y-1/2 w-[95vw] sm:w-[90vw] max-w-[1000px] h-[90vh] max-h-[800px] bg-[#212121] border-white/20 p-0 gap-0 rounded-lg overflow-hidden z-[100]"
      overlayClassName="bg-black/20 z-[95]"
      noCloseButton
      onInteractOutside={handleClose}
    >
      <DialogHeader className="p-4 border-b border-white/20 bg-[#212121] flex-shrink-0">
        <div className="flex items-center justify-between">
          <DialogTitle className="text-lg font-semibold text-white">
            {t('title')}
          </DialogTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            className="text-white hover:bg-white/10"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </DialogHeader>

      <div className="flex-1 overflow-hidden">
        <ElementLibrary />
      </div>
    </DialogContent>
  )
}
